import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {Observable} from 'rxjs';
import {tap, startWith, debounceTime,distinctUntilChanged, switchMap, map, filter} from 'rxjs/operators';
import {AsyncPipe} from '@angular/common';

import { DataService } from '../../../data.service';
import { CommonService } from '../../../services/common.service';
import { AppData } from '../../../constants/app-data';
import { UrlConstant } from '../../../constants/url-constant';
import { NotificationService } from "../../../services/notification.service";


import { Subject, BehaviorSubject } from 'rxjs';
@Component({
  selector: 'app-edu-sys-create',
  templateUrl: './edu-sys-create.component.html',
  styleUrls: ['./edu-sys-create.component.css']
})
export class EduSysCreateComponent implements OnInit {
  private formSubmitAttempt: boolean;
  formDataInvalid: boolean;
  submitBtnName = "Create";
  resetData: any;
  message: any;
  isPageForUpdate: boolean = false;
  
    //today's date
   todayDateFilter:Date = new Date();
	//any date
  //someDateFilter: Date = new Date(anydate);
   customDateFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
     return day !== 0 && day !== 6;
    }
  
  educationalSystem = new FormGroup({
    id: new FormControl(''),
    name: new FormControl('', [ Validators.minLength(6), Validators.maxLength(80) ]),
    subName: new FormControl('', [ Validators.maxLength(30) ]),
    nickName: new FormControl('', [ Validators.maxLength(30) ]),
    registrationNo: new FormControl('', [ Validators.minLength(6), Validators.maxLength(30) ]),
    affiliatedBy: new FormGroup({
      id: new FormControl(''),
      value: new FormControl('', [ Validators.minLength(2), Validators.maxLength(75) ])
    }),
    educationalSystemTypeStr: new FormControl(''),
    expiryDate: new FormControl(''),
    address: new FormGroup({
      id: new FormControl(''),
      addressLine1: new FormControl('', [ Validators.minLength(5), Validators.maxLength(50) ]),
      addressLine2: new FormControl('', [ Validators.minLength(5), Validators.maxLength(50) ]),
      city: new FormControl('', [ Validators.minLength(2), Validators.maxLength(30) ]),
      state: new FormControl('', [ Validators.minLength(2), Validators.maxLength(20) ]),
      country: new FormControl('', [ Validators.minLength(2), Validators.maxLength(50) ]),
      pinCode: new FormControl('', [ Validators.minLength(5), Validators.maxLength(50) ])
    }),
    owner: new FormGroup({
      id: new FormControl(''),
      firstName: new FormControl('', [Validators.maxLength(50) ]),
      middleName: new FormControl('', [Validators.maxLength(50) ]),
      lastName: new FormControl('', [Validators.maxLength(50) ]),
      individualTypeStr: new FormControl(''),
      loginUserId: new FormControl('', [ Validators.minLength(8), Validators.maxLength(50) ]),
      roleList: new FormControl('')
    })
  });
  
  affiliatedByOptions: any[] = [{id:"Self", value:"Self"}, {id:'NA', value:'NA'}];
  affiliatedByFilteredOptions: Observable<any[]>;
  
  constructor(private router: Router, private routeParams: ActivatedRoute, 
  			public appData: AppData, private dataService: DataService, private commonService: CommonService,
  			public notificationService: NotificationService) { }

  ngOnInit(): void {
  	let eduId = this.routeParams.snapshot.params['id'];
  	//this.routeParams.snapshot.data['type'];
  	this.resetData = this.prepareBlankData();
  	this.affiliatedByFilteredOptions = 	this.educationalSystem.get('affiliatedBy').get('value').valueChanges.pipe(
     startWith(''), debounceTime(500),
      map(value => this._filter(value || '')),
    );
 //   this.affiliatedByFilteredOptions = 	this.educationalSystem.get('affiliatedBy').get('value').valueChanges.pipe(
   //   startWith(''), debounceTime(500),//distinctUntilChanged(),
     // map((value) => {
       // return  this._filter(value);
 //     })
   // );
 // 	this.routeParams.params.subscribe(params => {
  		//this.educationalSystem.id = params['id'];
  		//console.log("--"+params['id']);
  		
  	//	if( params['id'] !== undefined){
  		//	this.getAndPopulateData({ 'id' : params['id'] });
  	//	}
  		//this.id = params['id'];
//    });
    if( eduId !== undefined){
    	this.submitBtnName = "Update";
		this.getAndPopulateData({ 'id' : eduId });
	}
    
  	//var param1 = $routeParams.param1;
  	if(this.appData.companyTypes === undefined)
  		this.commonService.prepareCompanyTypes();
  	
  	if(this.appData.individualTypes === undefined)
  		this.commonService.prepareIndividualTypes();
  	//console.log('hi');
  	
  	if(this.appData.userId === undefined || this.appData.userId === ""){ // if someone refresh page using browser refresh
  		this.appData.user.subscribe(user=> {
  			this.dataService.getLoggedInUserRolesOrPrivileges({'userId': this.appData.userId} , 'ROLE');
  		});
  	} else {
  		this.dataService.getLoggedInUserRolesOrPrivileges({'userId': this.appData.userId} , 'ROLE');
  	}
  	
  	//console.log(this.appData.allRoles.value());
  }
  
  getDefaultaffiliatedByOptions(){
	  return  [{id:"Self", value:"Self"}, {id:'NA', value:'NA'}];
  }
  
  _filter(value: string): any[] {
	  if(value == '')
	  	return this.getDefaultaffiliatedByOptions();
	  else {
		 //return this.affiliatedByOptions;
		//console.log(value)
		// this.dataService.sendPostRequestWithBodyOnPipe(UrlConstant.apiGetAffiliatorSuggesition, {'key':value}).subscribe((res)=>{
		 this.dataService.sendPostRequestWithBody(UrlConstant.apiGetAffiliatorSuggesition, {'key':value}).subscribe((res:any)=>{
			 console.log(res);
			 let d = res;
			 // tap(res=>{d= res});
			 if("SUCCESS" === d.status){
				 this.affiliatedByOptions=res.data;
			 	console.log(this.affiliatedByOptions);
				//d.data.forEach((k,v)=>this.affiliatedByOptions.push({'name':k, desc:v}));
			 	return this.affiliatedByOptions;
			 }else
			 	console.log(this.educationalSystem.get('affiliatedBy').get('id'));
			 
		  }); 
	  }
  }
  
  onSelectOfAffiliatedByOption(event){
	 // console.log(event);
	 // console.log('onselect:'+ event.source.value);
	  
  }
  onAutoCompleteSelection(event){
	 // console.log(event);
	 // console.log('onselect:'+ event.option.value);
  }
  getAndPopulateData(body){
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiGetEducationalSystem, body).subscribe((res: any)=>{
  	 //{"status":"SUCCESS","message":null,"data":[{"pageNumber":null,"recordsPerPage":null,"baseData":null,"id":2,"name":"Meera Institute","subName":"","nickName":"","registrationNo":"MeeraInstitute","status":"ACTIVE","affiliatedBy":{"id":"Self","value":"Self"},"address":{"id":2,"addressLine1":"M K Sinha, Amardeep Nagar","addressLine2":"(Ramkrishna Nagar), PO-Dhelwa(South),","city":"Patna","state":"Bihar","pinCode":"800020","country":"India","addressType":"COMPANY"},"contactList":[],"educationalSystemType":"COACHING","createdForCompany":null,"owner":{"pageNumber":null,"recordsPerPage":null,"baseData":null,"id":84,"loginUserId":"meera@gmail.com","firstName":"Meera","middleName":"Kumari","lastName":"Sinha","individualType":"OWNER","status":"ACTIVE","addressList":[],"contactList":[],"roleList":[],"createdForCompany":2}}],"redirectTo":null}
      //console.log(res);
      if(res.data.length > 0){
		  if(res.data[0].expiryDate!==null && res.data[0].expiryDate!=undefined)
			res.data[0].expiryDate = new Date(res.data[0].expiryDate);
      	this.updateUIData(res.data[0]);
      	this.isPageForUpdate = true;
      	//res.data[0].educationalSystemTypeStr = res.data[0].educationalSystemType;
      	//res.data[0].owner.individualTypeStr = res.data[0].owner.individualType;
      	//this.resetData = res.data[0];
      	//this.educationalSystem.patchValue(this.resetData);
      	if(res.data[0].id !== 1 && res.data[0].owner) // Not a Tiral Enterprise
      		this.updateAssignedRoles({'userId':res.data[0].owner.loginUserId});
      }
    });
  }
  
  updateUIData(dataObject){
  	dataObject.educationalSystemTypeStr = dataObject.educationalSystemType;
  	if(dataObject.id === 1 && !dataObject.owner){ //Trial Enterprise
  		this.resetData = this.prepareBlankData();
  		if(dataObject.expiryDate!==null && dataObject.expiryDate!=undefined)
			this.resetData.expiryDate = new Date(dataObject.expiryDate);
		else
			this.resetData.expiryDate = dataObject.expiryDate;
  		this.resetData.id = dataObject.id;
  		this.resetData.name = dataObject.name;
  		this.resetData.registrationNo = dataObject.registrationNo;
  		this.resetData.status = dataObject.status;
  		this.resetData.educationalSystemType = dataObject.educationalSystemType;
  		this.resetData.educationalSystemTypeStr = dataObject.educationalSystemType;
  	} else {
  		this.resetData = dataObject;
  		if(this.resetData.affiliatedBy == null || this.resetData.affiliatedBy == undefined)
  			this.resetData.affiliatedBy = this.prepareBlankData().affiliatedBy;
  		this.resetData.educationalSystemTypeStr = dataObject.educationalSystemType;
  		this.resetData.owner.individualTypeStr = dataObject.owner.individualType;
  	}
  	//dataObject.owner.individualTypeStr = dataObject.owner?dataObject.owner.individualType:"";
  	
  	this.educationalSystem.patchValue(this.resetData);
  }
  
  updateAssignedRoles(body){
	this.dataService.sendPostRequestWithBody(UrlConstant.apiGetLoggedInUserAllRoles, body).toPromise().then((data: any)=>{
		if("SUCCESS" === data.status){
			console.log(this.resetData.owner);
			data.data.forEach( role => { this.resetData.owner.roleList.push(role.id); } );
			this.educationalSystem.patchValue(this.resetData);
			//this.resetData.owner.roleList = r;
		}
	});
  }

  	onSubmit() {
		  // TODO: Use EventEmitter with form value
	    var reqBody = this.educationalSystem.value;
	    console.log('----'+reqBody.id);
	    this.formSubmitAttempt = false;
	    if (this.educationalSystem.valid) {
	      try {
	      	let url = UrlConstant.apiCreateEducationalSystem;
		      console.log(reqBody);
		      if(reqBody.id !== ''){
		      	url = UrlConstant.apiUpdateEducationalSystem;
		      } 
		      let match = false;
		      this.affiliatedByOptions.forEach(d =>{
				  if(d.id == reqBody.affiliatedBy.value){
					  reqBody.affiliatedBy.id = d.value;
					  match = true;
				  }
			  });
			  if(match == false){
				  reqBody.affiliatedBy.id = null;
			  }
		 	  this.dataService.sendPostRequestWithBody(url ,reqBody).subscribe((data: any)=>{
		 		console.log(data);
			      if("SUCCESS" === data.status){
			      	console.log("success code");
			      	if(data.data.expiryDate!==null && data.data.expiryDate!=undefined)
						data.data.expiryDate = new Date(data.data.expiryDate);
			      	this.updateUIData(data.data);
			      	if(reqBody.id !== ''){
				      	this.notificationService.success("Enterprise Updated Successfully. ");
				     } else {
				     	this.message = "Please login with password: " + data.message;
				      	//this.notificationService.success("Enterprise Created Successfully. " + this.message);
				      	this.notificationService.openSnackBar("Enterprise Created Successfully. "+this.message, 'Close', 'green-snackbar', 0);
				     }
		      		//this.router.navigate(['/dashboard', { 'userId': '' }]);
			      } else {
			        console.log("fail code");
			        this.notificationService.error(data.message);
		      		//this.router.navigate(['/dashboard', { 'userId': username }]);
			      }
			  });
		    
	      } catch (err) {
	        console.log(err);
	      }
	    } else {
	      this.formSubmitAttempt = true;
	      this.formDataInvalid = true;
	    }
		  
	  
	}

	prepareBlankData(){
		return {
	    id: '',
	    name: '',
	    subName: '',
	    nickName: '',
	    registrationNo: '',
	    affiliatedBy:  {
	      id: '',
	      value:''
	    },
	    expiryDate:'',
	    address: {
	      addressLine1: '',
	      addressLine2: '',
	      city: '',
	      state: '',
	      country: 'India',
	      pinCode: ''
	    },
	    
	    owner: {
	      id: '',
	      firstName: '',
	      middleName: '',
	      lastName: '',
	      individualTypeStr: '',
	      loginUserId: '',
	      roleList: []
	     }
	  };
	}
	
	clearEducationSystem() {
		console.log("Clear::");
	  	this.educationalSystem.patchValue(this.resetData);
	}
	
	viewIndividualMember(){
		this.appData.selectedComapnyId = this.educationalSystem.value.id;
		this.router.navigate(['/individual-view', {}]);
	}
	
}
